import {
  autoFormatZipcode,
  convertCharterFullWidth,
  getAddressByZipcode,
} from "@lhd/utility";
import { ChangeEvent, useState } from "react";
import { ICommonFieldProps } from "../../../../interfaces";
import { REGEX } from "@lhd/constants";
import { useFetchPrefecturesOptions } from "@lhd/hooks";
import { message } from "antd";

const formatZipcode = (value: string) => {
  const halfWidthValue = convertCharterFullWidth(value);
  const isValidZipcode = REGEX.ZIP_CODE.test(halfWidthValue);

  if (!isValidZipcode) return value;

  return autoFormatZipcode(halfWidthValue);
};

const ZipcodeEditCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange, colDef, handleSetValue, handleRefreshRow } =
    props;
  const [value, setValue] = useState(String(defaultValue ?? ""));
  const { data: prefectureOptions } = useFetchPrefecturesOptions();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    onChange?.(event);
  };

  const handleBlur = async () => {
    const formattedValue = formatZipcode(value);
    try {
      const { code, data } = await getAddressByZipcode(formattedValue);
      if (code === "error") {
        message.error("郵便番号から住所を取得できませんでした。");
      } else if (data?.data) {
        let nameFieldAddress = colDef?.editInfo?.fieldAddress || "";
        let nameFieldPrefecture = colDef?.editInfo?.fieldPrefecture || "";
        if (colDef?.field?.includes(".")) {
          const fields = colDef.field.split(".");
          const typeZipcode =
            fields.length === 1 ? fields[0] : fields.slice(0, -1).join(".");
          nameFieldAddress = `${typeZipcode}.${nameFieldAddress}`;
          nameFieldPrefecture = `${typeZipcode}.${nameFieldPrefecture}`;
        }
        const prefecture = prefectureOptions?.find(
          (item) => data.data.prefecture === item.label,
        );
        handleSetValue({
          colIdParam: nameFieldAddress,
          value: data.data.fullAddress,
        });
        if (prefecture) {
          handleSetValue({
            colIdParam: nameFieldPrefecture,
            value: prefecture.label,
          });
        }
      }
    } catch {
      message.error("郵便番号から住所を取得できませんでした。");
    } finally {
      setValue(formattedValue);
      if (formattedValue !== value) {
        onChange?.(formattedValue);
      }
      handleRefreshRow();
    }
  };

  return (
    <input
      className="input-field"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default ZipcodeEditCell;
